import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", testId: "footer-link-home" },
  { to: "/products/laic", label: "LAIC — LGU AI Companion", testId: "footer-link-laic" },
  { to: "/products/vision", label: "MAC AI Vision", testId: "footer-link-vision" },
  { to: "/about", label: "Who We Are", testId: "footer-link-about" },
  { to: "/contact", label: "Request a Demo", testId: "footer-link-contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-mac-surface/40">
      <div className="glow-line" />
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <img
              src="/media/mac-logo-square.png"
              alt="MAC AI Business Solutions logo"
              data-testid="footer-logo"
              className="h-24 w-24 rounded-full border border-mac-accent/40 object-cover shadow-[0_0_32px_rgb(var(--mac-accent-rgb)/0.25)]"
            />
            <p className="mt-5 max-w-xs font-display text-xl font-semibold uppercase tracking-widest text-slate-300">
              Automate. Innovate. Grow.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-500">
              AI-powered e-governance and vision intelligence for governments, LGUs, and institutions.
            </p>
          </div>
          <div>
            <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Site</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.testId}>
                  <Link
                    to={l.to}
                    data-testid={l.testId}
                    className="text-sm text-slate-400 transition-colors duration-300 hover:text-mac-accent"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Contact</p>
            <a href="mailto:info@macaisolutions.com" data-testid="footer-email-link" className="flex items-center gap-2.5 text-sm text-slate-400 transition-colors duration-300 hover:text-mac-accent">
              <Mail className="h-4 w-4 text-mac-accent" /> info@macaisolutions.com
            </a>
            <p className="mt-4 flex items-center gap-2.5 text-sm text-slate-400">
              <MapPin className="h-4 w-4 text-mac-accent" /> Cebu City, Philippines
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-widest text-slate-600">
            © 2026 MAC AI Business Solutions
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-slate-600">
            RA 10173 compliant — detection, not identification
          </p>
        </div>
      </div>
    </footer>
  );
}
